export const defaultMediaPlatformCreateRecord = {
  settings: {
    enable_pulling_data_tune: true,
    enable_pulling_data_trackcb: true,
    enable_pulling_data_clicks: true
  }
};
